import React, { useState, useMemo } from 'react'
import { Header, Icon, Form, Button } from 'semantic-ui-react'
import { DateTime, Interval } from 'luxon'
import InputMask from 'react-input-mask'
import { toast } from 'react-toastify'
import request from 'services/http'
import { tap, finalize } from 'rxjs/operators'
import { useSubscription } from 'utils'
import history from 'services/history'

export default function ConferenciaForm({ path, empresas, formConferencia, setFormConferencia, setConferencia }) {

    const [type, setType] = useState('mes')
    const [month, setMonth] = useState()
    const [isSubmitting, setIsSubmitting] = useState(false)

    const submit$ = useMemo(() => request({
        url: '/nfce/conferencia',
        method: 'GET',
        params: formConferencia
    }).pipe(
        tap(({ response }) => {
            setConferencia(response)
            setTimeout(() => history.push(`${path}/relatorios/detalhamento?${new URLSearchParams(formConferencia).toString()}`), 50)
        }),
        finalize(() => setIsSubmitting(false))
    ), [formConferencia, setConferencia, path])

    const mesOptions = Interval.fromDateTimes(DateTime.local().startOf('month').minus({ months: 3 }), DateTime.local()).splitBy({ month: 1 })
        .map(dateTime => ({ 
            text: dateTime.start.monthLong.charAt(0).toUpperCase() + dateTime.start.monthLong.slice(1) + "/" + dateTime.end.year, 
            value: dateTime.start.toFormat('yyyyMMdd')
        }))

    function handleChange(event, props) {
        let name = props ? props.name : event.target.name, value = props ? props.value : event.target.value
        switch (name) {
            case 'periodo':
                const dateTime = DateTime.fromFormat(value, "yyyyMMdd")
                setFormConferencia({ payload: { dataInicial: dateTime.toFormat('dd/MM/yyyy'), dataFinal: dateTime.endOf('month').toFormat('dd/MM/yyyy') } })           
                setMonth(value)
                break
            case 'tipo':
                setType(value)
                break
            default:
                setFormConferencia({ payload: { [name]: value } })
                break
        }
    }

    function handleSubmit() {
        if (!(!!formConferencia.empresa) && !(!!formConferencia.dataInicial))
            toast.error('Há campos não preenchidos')
        else 
            setIsSubmitting(true)
    }

    useSubscription(submit$, isSubmitting)

    return (
        <div className="col d-flex flex-column flex-grow-1">
            <Header as='h3'>
                <Icon.Group size='big'>
                    <Icon name='clipboard list' className='primary-color' />
                </Icon.Group>
                <Header.Content className='primary-color'>
                    Conferência
                    <Header.Subheader className='secondary-color'>
                        <strong>Relatórios de conferência</strong>
                    </Header.Subheader>
                </Header.Content>
            </Header>
            <div className='d-flex flex-column flex-grow-1 align-items-center justify-content-center'>                
                <Form size='mini' className='w-100' onSubmit={handleSubmit} loading={isSubmitting} noValidate>
                    <div className="row">
                        <div className="col col-md-8 offset-md-2">
                            <Form.Select search noResultsMessage='Nenhum resultado encontrado' required label='Empresa' placeholder='Selecionar empresa' name='empresa' value={formConferencia.empresa} onChange={handleChange} options={empresas ? empresas.map(x => ({ text: x.codDpnet + ' - ' + x.nomeEmpresa, value: x._id })) : []} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col col-md-8 offset-md-2">
                            <Form.Select required label='Pesquisar por' name='tipo' value={type} onChange={handleChange} options={[{ text: 'Mês', value: 'mes' }, { text: 'Datas', value: 'datas' } ]} />
                        </div>
                    </div>
                    {type === 'mes' && <div className="row mt-2">
                        <div className="col col-md-8 offset-md-2">
                            <Form.Select required label='Mês' placeholder='Selecione o periodo' name='periodo' value={month} onChange={handleChange} options={mesOptions} />
                        </div>
                    </div>}
                    {type === 'datas' && <div className='row mt-2'>
                        <div className="col col-md-4 offset-md-2">
                            <InputMask mask='99/99/9999' name='dataInicial' value={formConferencia.dataInicial} onChange={handleChange} >
                                {inputProps => <Form.Input {...inputProps} required label='Data inicial' placeholder='Informe data inicial' />}
                            </InputMask>
                        </div>
                        <div className="col col-md-4">
                            <InputMask mask='99/99/9999' name='dataFinal' value={formConferencia.dataFinal} onChange={handleChange} >
                                {inputProps => <Form.Input {...inputProps} required label='Data final' placeholder='Informe data final' />}
                            </InputMask>
                        </div>
                    </div>}
                    <div className="row mt-4">
                        <div className="col text-center">
                            <Button size='mini' color='green'><Icon name='send' /> Consultar</Button>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}
